import { useContext } from 'react'
import { ChannelsCommandList } from '~/features/command-lists'

import { FilterContext } from '../filter-context'
import { useFilterMutator } from '../hooks'

export function ChannelFilterControl() {
  const { contextFilters } = useContext(FilterContext)
  const { onSelect, selection } = useFilterMutator()
  return (
    <ChannelsCommandList
      multiselect
      selected={selection}
      onSelect={onSelect}
      contextFilters={contextFilters?.channelId ? { id: contextFilters.channelId } : {}}
    />
  )
}
